import React from 'react';

export const BecomeMemberComponent = () => {
  return (
    <div
      className='d-flex loadingContainer'
      style={{
        paddingTop: 15,
        paddingBottom: 15,
        margin: 'auto',
        marginTop: '40px',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span style={{ fontSize: 22, fontFamily: 'Editorial New', fontWeight: 500 }}>
        Ready to join the sqaud?
      </span>
      <span className={'mt-3 mb-5'} style={{ textAlign: 'center', fontSize: 15 }}>
        Become a member to unlock the full potential of our shared campus
        closet.
        <br />
        Just click the button below to get started!
      </span>
      <a
            href={'https://commonthreads.com/products/membership'}
            target='_parent'
            color='primary'
            className='btn btn-primary text-uppercase px-5'
            style={{
              fontFamily: 'Brown',
              fontWeight: 500,
              paddingTop: 6,
              letterSpacing: 2,
              paddingBottom: 6,
              height: 36,
            }}
          >
            join now
          </a>
    </div>
  );
};
